import React from 'react';

import { useNavigate } from 'react-router-dom';
import { HelpSectionNav, getSectionNavigation } from '@ergeon/help-components';

import { WIKI_ALL_SECTIONS_LABEL } from '../constants';
import { WikiNode } from '../types';

import { WIKI_SECTIONS } from './sections';

const SECTION_NAV_LABELS = { allTopics: WIKI_ALL_SECTIONS_LABEL };

export const isInsideSection = (node: WikiNode | null) => {
  const { parentKey } = getSectionNavigation(node, WIKI_SECTIONS, WIKI_ALL_SECTIONS_LABEL);
  return Boolean(parentKey);
};

const SectionTree = ({ node }: { node: WikiNode | null }) => {
  const navigate = useNavigate();

  if (!node || !isInsideSection(node)) {
    return null;
  }

  return (
    <div className="border-t border-gray-200 pt-4 dark:border-gray-800">
      <HelpSectionNav
        categories={WIKI_SECTIONS}
        currentNodeKey={node.nodeKey}
        labels={SECTION_NAV_LABELS}
        node={node}
        onNavigate={navigate} />
    </div>
  );
};

export default SectionTree;
